import React, { useState, useEffect } from "react";
import { authFetch, httpClient } from '../../../../HttpClient';
import { uploadFileToBlob } from "../../../../utils/uploadFileToBlob";

import { dialog } from "../../../../components/ui/Dialog";
import { normalizeText } from "../../../../utils/text.js";
import {
  FileText,
  AlertCircle,
  Loader2,
  Check,
  ChevronUp,
  ChevronDown,
} from "lucide-react";

const CreateTodo = ({ item, itemtype, onClose, fetchData, suiviBilanId }) => {
  const [files, setFiles] = useState({
    bilanDocument: null,
    identityDocument: null,
    kbisDocument: null,
    statusDocument: null,
    pieceIdentite: null,
  });
  const [formData, setFormData] = useState({
    title: item?.title || "",
    status: "En cours",
    type: itemtype,
    nomClient: item?.client?.nom?.trim() ? item.client.nom : item.nomSociete,
    clientId: item?.clientId || "",
    eventId: item?.eventId || "",
    formLeadId: item?.formLeadId || null,
    userIds: [],
    nature: item?.nature || "",
    dueDate: item?.dueDate || "",
    priority: item?.priority || "classique",
    commentaire: item?.commentaire || "",
  });

  console.log("Initial formData:", formData);
  console.log("item:", item.id);

  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(null);

  const [searchUser, setSearchUser] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [ChaqueAssocieDocument, setChaqueAssocieDocument] = useState(false);

  const handleSearchUser = (e) => {
    const q = e.target.value;
    setSearchUser(q);

    if (q.length < 2) {
      setUserSuggestions([]);
      return;
    }

    const filtered = allUsers.filter(
      (user) =>
        normalizeText(`${user.name} ${user.lastName}`).includes(
          normalizeText(q),
        ) && !formData.userIds.includes(user.id)
    );

    setUserSuggestions(filtered);
  };

  const selectUser = (user) => {
    if (!formData.userIds.includes(user.id)) {
      setFormData((prev) => ({
        ...prev,
        userIds: [...prev.userIds, user.id],
      }));
    }
    setSearchUser("");
    setUserSuggestions([]);
  };

  useEffect(() => {
    if (item) {
      setFormData({
        title: item.title || "",
        status: "En cours",
        type: itemtype,
        nomClient: item?.client?.nom?.trim()
          ? item.client.nom
          : item.nomSociete?.trim()
          ? item.nomSociete
          : item.nom,
        clientId: item.clientId || "",
        formLeadId: item?.formLeadId || null,
        eventId: item.eventId || "",
        userIds: item.userIds || [],
        nature: item.nature || "",
        dueDate: item.dueDate || "",
        priority: item.priority || "classique",
        commentaire: item.commentaire || "",
      });

      if (item.userIds) {
        setSearchUser("");
      }
    }
  }, [item, itemtype]);

  const [notifyByEmail, setNotifyByEmail] = useState(true);

  useEffect(() => {
    // Charger les utilisateurs pour userIds[]
    authFetch("https://backend-myalfa.vercel.app/api/users")
      .then((res) => res.json())
      .then((data) => setAllUsers(data))
      .catch((err) => console.error("Erreur chargement utilisateurs", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRemoveUser = (idToRemove) => {
    setFormData((prev) => ({
      ...prev,
      userIds: prev.userIds.filter((id) => id !== idToRemove),
    }));
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: selectedFiles[0],
      }));
    }
  };

  const emailUsers = allUsers
    .filter((user) => formData.userIds.includes(user.id))
    .map((user) => user.email);

  console.log("Liste des emails des utilisateurs sélectionnés :", emailUsers);

  let modifSocietesId = null;
  let droitSocId = null;
  let RadiationId = null;
  let autresMissionId = null;

  if (itemtype === "MissionDroitSoc") {
    droitSocId = item.id;
  } else if (itemtype === "MissionModifSoc") {
    modifSocietesId = item.id;
  } else if (itemtype === "Radiation") {
    RadiationId = item.id;
  } else if (itemtype === "autresMission") {
    autresMissionId = item.id;
  }

  let todoPayload = {
    title: formData.title,
    status: formData.status,
    type: itemtype,
    nomClient: item?.client?.nom?.trim() ? item.client.nom : item.nomSociete,
    clientId: item.clientId || null,
    formLeadId: item.formLeadId || null,
    userIds: formData.userIds,
    nature: formData.type,
    dueDate: formData.dueDate,
    priority: formData.priority,
    commentaire: formData.commentaire,
    modifSocietesId,
    droitSocId,
    RadiationId,
    autresMissionId,
  };

  if (itemtype === "SuiviBilan" || itemtype === "SuiviSocial") {
    todoPayload = {
      ...todoPayload,
      clientId: item?.client?.id ?? item?.id ?? null,
      formLeadId: item?.formLeadId || null,
      // tu peux ajouter ici d’autres champs spécifiques
    };
  }

  console.log("Payload TODO :", todoPayload);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("title", todoPayload.title);
      formDataToSend.append("status", todoPayload.status);
      formDataToSend.append("type", todoPayload.type);
      formDataToSend.append("nomClient", todoPayload.nomClient);
      formDataToSend.append("clientId", todoPayload.clientId);
      formDataToSend.append("formLeadId", todoPayload.formLeadId);
      formDataToSend.append("eventId", todoPayload.eventId);
      formDataToSend.append("nature", todoPayload.nature);
      formDataToSend.append("dueDate", todoPayload.dueDate);
      formDataToSend.append("priority", todoPayload.priority);
      formDataToSend.append("commentaire", todoPayload.commentaire);

      // userIds en tableau
      todoPayload.userIds.forEach((id) => formDataToSend.append("userIds", id));

      // =========================
      // FICHIERS — upload direct navigateur → Blob (contourne la limite
      // 4,5 Mo), avec une progression affichée pendant l'envoi.
      // =========================
      const fileEntries = Object.entries(files).filter(([, file]) => file);
      for (const [key, file] of fileEntries) {
        setUploadProgress(0);
        const url = await uploadFileToBlob(
          file,
          "https://backend-myalfa.vercel.app/api/todos/upload-token",
          ({ percentage }) => setUploadProgress(Math.round(percentage))
        );
        formDataToSend.append(`${key}Url`, url);
      }
      setUploadProgress(null);

      const response = await authFetch("https://backend-myalfa.vercel.app/api/todos",
        {
          method: "POST",
          body: formDataToSend, // ⚠️ pas de headers
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la création du TODO.");
      }

      // 📌 Cas spécifique SuiviBilan → HistoriqueSuiviBilan
      if (itemtype === "SuiviBilan" && suiviBilanId) {
        try {
          await httpClient.post(
            "https://backend-myalfa.vercel.app/api/historiqueSuiviBilan",
            {
              titre: "Création d'un todo",
              description: formData.title?.trim() || "Pas de description",
              suiviBilanId: suiviBilanId,
            }
          );
          console.log("✅ Historique ajouté (SuiviBilan) !");
        } catch (error) {
          console.error(
            "❌ Erreur lors de l’ajout d’historique SuiviBilan :",
            error
          );
        }
      }

      // 📌 Tous les autres cas (missions, radiation, etc.) → HistoriquesMission
      if (itemtype !== "SuiviBilan" && itemtype !== "SuiviSocial") {
        let historiquePayload = {};

        if (itemtype === "MissionDroitSoc") {
          historiquePayload = {
            title: "Todo Mission de Droit Sociaux",
            description: item?.commentaire?.trim() || "Pas de commentaire",
            droitSocId: item.id,
          };
        } else if (itemtype === "MissionModifSoc") {
          historiquePayload = {
            title: "Todo Mission de Modification de société",
            description: item?.commentaire?.trim() || "Pas de commentaire",
            modifSocieteId: item.id,
          };
        } else if (itemtype === "MissionCreation") {
          historiquePayload = {
            title: "Todo Mission de Création de société",
            description: item?.commentaire?.trim() || "Pas de commentaire",
            creationSctId: item.id,
          };
        } else if (itemtype === "Radiation") {
          historiquePayload = {
            title: "Todo Mission de Radiation",
            description: item?.commentaire?.trim() || "Pas de commentaire",
            creationSctId: item.id,
          };
        } else if (itemtype === "autresMission") {
          historiquePayload = {
            title: "Todo Autres Mission",
            description: item?.commentaire?.trim() || "Pas de commentaire",
            creationSctId: item.id,
          };
        }

        if (Object.keys(historiquePayload).length > 0) {
          const historiqueRes = await authFetch("https://backend-myalfa.vercel.app/api/historiquesMission",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(historiquePayload),
            }
          );

          if (!historiqueRes.ok) {
            throw new Error(
              "Erreur lors de l'ajout à l'historique de mission."
            );
          }

          console.log("✅ Historique bien ajouté :", historiquePayload);
        }
      }

      // 📧 Notification par mail
      if (notifyByEmail) {
        await authFetch("https://backend-myalfa.vercel.app/api/mail-todo-create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: formData.title,
            status: formData.status,
            type: itemtype,
            nomClient: item?.client?.nom?.trim()
              ? item.client.nom
              : item.nomSociete?.trim()
              ? item.nomSociete
              : item.nom,
            dueDate: formData.dueDate,
            priority: formData.priority,
            emailUsers: emailUsers || [],
            commentaire: formData.commentaire,
          }),
        });
      }

      dialog.alert("TODO créé avec succès !");
    } catch (err) {
      console.error(err);
      dialog.alert("Erreur création TODO");
    } finally {
      setUploadProgress(null);
      setLoading(false);
      if (itemtype !== "SuiviBilan") {
        fetchData();
      }
      onClose();
    }
  };

  const isFormInvalid =
    !formData.nomClient?.trim() ||
    !formData.userIds ||
    formData.userIds.length === 0;

  return (
    <div className="flex flex-col w-full">
      <div className="px-8 pt-6 pb-4 border-b bg-gradient-to-r from-[#9B1B5D]/5 to-transparent mb-5">
        <div className="text-2xl font-bold text-slate-900 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#9B1B5D] flex items-center justify-center">
            <FileText className="w-5 h-5 text-white" />
          </div>
          Création de tâche Todo
        </div>
      </div>
      <form
        className="w-full px-8"
        onSubmit={handleSubmit}
        encType="multipart/form-data"
      >
        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className="mb-4"
          >
            <p style={{ width: "100%", margin: 0 }}>
              Créer un Todo pour le client : {""}
              <strong>
                {item?.client?.nom?.trim()
                  ? item.client.nom
                  : item.nomSociete?.trim()
                  ? item.nomSociete
                  : item.nom}
              </strong>
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-4 ">
            <div>
              <label className="text-sm font-semibold text-slate-700">
                Date d'échéance
              </label>
              <input
                className="
                                      mt-2
                                      w-full
                                      h-11
                                      rounded-md
                                      bg-white
                                      px-3
                                      text-sm
                                      outline-none
                                      transition-all
                                      border-2
                                      border-slate-300
                                      focus:border-emerald-400
                                    "
                type="date"
                name="dueDate"
                value={formData.dueDate}
                onChange={handleChange}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700">
                Priorité
              </label>
              <select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                className="
                      mt-2
                      w-full
                      h-11
                      rounded-md
                      bg-white
                      px-3
                      text-sm
                      outline-none
                      transition-all
                      border-2
                      border-slate-300
                      focus:border-emerald-400
                    "
              >
                <option value="classique">Classique</option>
                <option value="élevée">Élevée</option>
                <option value="basse">Basse</option>
              </select>
            </div>
          </div>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: "100%",
            }}
          >
            <input
              type="checkbox"
              checked={notifyByEmail}
              onChange={(e) => setNotifyByEmail(e.target.checked)}
            />
            Notifier par Email les collaborateurs
          </label>
          <hr className="mt-5 mb-5" />

          <div className="relative w-full">
            <label className="text-sm font-semibold flex items-center gap-2 text-slate-700">
              Collaborateur lié à la tâche
              <span className="text-red-500">( champ obligatoir ) </span>
            </label>

            <input
              type="text"
              value={searchUser}
              onChange={handleSearchUser}
              placeholder="Rechercher un utilisateur…"
              autoComplete="off"
              className="
      mt-2
      w-full
      h-11
      rounded-md
      bg-white
      px-3
      text-sm
      outline-none
      transition-all
      border-2
      border-slate-300
      focus:border-emerald-400
    "
            />

            {userSuggestions.length > 0 && (
              <ul
                className="
        absolute
        left-0
        top-full
        mt-1
        w-full
        max-h-60
        overflow-y-auto
        rounded-md
        border
        border-slate-200
        bg-white
        shadow-lg
        z-20
      "
              >
                {userSuggestions.map((user) => (
                  <li
                    key={user.id}
                    onClick={() => selectUser(user)}
                    className="
            cursor-pointer
            px-3
            py-2
            text-sm
            text-slate-700
            hover:bg-slate-100
            transition-colors
            border-b
            last:border-b-0
          "
                  >
                    {user.name} {user.lastName}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Liste des utilisateurs sélectionnés */}
          <div className="mt-4">
            {formData.userIds.length === 0 ? (
              <p className="text-sm text-slate-400 italic">
                Aucun utilisateur ajouté.
              </p>
            ) : (
              <div className="flex flex-wrap gap-2">
                {formData.userIds.map((id) => {
                  const user = allUsers.find((u) => u.id === id);
                  return (
                    <div
                      key={id}
                      className="
              flex
              items-center
              gap-2
              bg-emerald-50
              border
              border-emerald-200
              text-emerald-700
              px-3
              py-1.5
              rounded-full
              text-sm
            "
                    >
                      <span>
                        {user?.name || "Utilisateur inconnu"}{" "}
                        {user?.lastName || ""}
                      </span>

                      <button
                        type="button"
                        onClick={() => handleRemoveUser(id)}
                        className="
                text-emerald-600
                hover:text-red-500
                font-medium
                transition-colors
              "
                      >
                        ✕
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 mt-4">
          <label className="text-sm font-semibold flex items-center gap-2 mb-3">
            <FileText className="w-4 h-4 text-slate-500" />
            Détails de la tâche
          </label>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700">Titre</label>
            <input
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Titre"
              required
              className={`
                    mt-2
                    h-11
                    w-full
                    rounded-md
                    bg-white
                    px-3
                    text-sm
                    border-2
                    outline-none
                    transition-all
                    ${
                      formData.title
                        ? "border-emerald-300 focus:border-emerald-400"
                        : "border-slate-300 focus:border-slate-400"
                    }
                  `}
            />
          </div>

          <div className="grid grid-cols-2 gap-4 mt-3">
            <div>
              <label className="text-sm font-semibold text-slate-700">
                Status
              </label>
              <select
                className="
        mt-2
        w-full
        h-11
        rounded-md
        bg-white
        px-3
        text-sm
        outline-none
        transition-all
        border-2
        border-slate-300
        focus:border-emerald-400
      "
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">-- Status --</option>
                <option value="En cours">En cours</option>
                <option value="Terminer">Terminer</option>
                <option value="Annuler">Annuler</option>
              </select>
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700">
                Type
              </label>
              <select
                className="
        mt-2
        w-full
        h-11
        rounded-md
        bg-white
        px-3
        text-sm
        outline-none
        transition-all
        border-2
        border-slate-300
        focus:border-emerald-400
      "
                name="type"
                value={formData.type}
                onChange={handleChange}
              >
                <option value="">-- Type de tâches --</option>
                <option value="autres">Autres</option>
                <option value="Preparation">DPA-0</option>
                <option value="Diligences">Diligences NpMQ & LAB</option>
                <option value="evenement">Evenement</option>
                <option value="Verification">
                  Vérification des premiers obligations fiscales
                </option>
                <option value="dext">Paramétrage comptabilité/dext</option>
                <option value="MissionDroitSoc">
                  Mission de droit sociaux
                </option>
                <option value="MissionModifSoc">
                  Mission De modification de société
                </option>
                <option value="MissionCreation">
                  Mission De création de société
                </option>
                <option value="Radiation">Mission De Radiation</option>
                <option value="SuiviBilan">Suivi Bilan</option>
                <option value="SuiviSocial">Suivi Social</option>
                <option value="SuiviJuridique">Suivi JuridiqueAGO</option>
                <option value="autresMission">Autres Mission</option>
              </select>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700 mb-1 block">
              Description
            </label>
            <textarea
              name="commentaire"
              value={formData.commentaire}
              onChange={handleChange}
              placeholder="Description"
              rows={4}
              className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
            />
          </div>
        </div>

        <div className="mt-6 bg-slate-50 rounded-xl border border-slate-200">
          <button
            type="button"
            onClick={() => setChaqueAssocieDocument(!ChaqueAssocieDocument)}
            className="w-full p-3 flex items-center justify-between hover:bg-slate-100 transition-colors rounded-t-xl"
          >
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Envoyer des documents avec cette tâche (optionnel)
            </span>

            <span className="text-slate-500">
              {ChaqueAssocieDocument ? (
                <ChevronUp className="w-4 h-4 text-slate-500" />
              ) : (
                <ChevronDown className="w-4 h-4 text-slate-500" />
              )}
            </span>
          </button>
          {ChaqueAssocieDocument && (
            <div className="p-4 space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Document 1
                </label>
                <input
                  type="file"
                  name="bilanDocument"
                  onChange={handleFileChange}
                  accept=".pdf,.docx,.png,.jpg,.jpeg,.webp,.xls,.xlsx"
                  className="w-full border rounded p-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Document 2
                </label>
                <input
                  type="file"
                  name="identityDocument"
                  onChange={handleFileChange}
                  accept=".pdf,.docx,.png,.jpg,.jpeg,.webp"
                  className="w-full border rounded p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Document 3
                </label>
                <input
                  type="file"
                  name="kbisDocument"
                  onChange={handleFileChange}
                  accept=".pdf,.png,.jpg,.jpeg"
                  className="w-full border rounded p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Document 4
                </label>
                <input
                  type="file"
                  name="statusDocument"
                  onChange={handleFileChange}
                  accept=".pdf,.docx"
                  className="w-full border rounded p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Document 5
                </label>
                <input
                  type="file"
                  name="pieceIdentite"
                  onChange={handleFileChange}
                  accept=".pdf,.png,.jpg,.jpeg,.webp"
                  className="w-full border rounded p-2"
                />
              </div>
            </div>
          )}
        </div>

        <br />

        <div className="sticky bottom-0 bg-white border-t mt-4 px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className={`
  px-8
  h-11
  border-2
  border-slate-300
  text-slate-700
  rounded-md
  font-medium
  hover:bg-slate-100
  transition-colors
`}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={loading || isFormInvalid}
            className={`
    w-1/2
    h-11
    ${
      loading || isFormInvalid
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-[#9B1B5D] hover:bg-[#7A1548]"
    }
    text-white
    text-base
    font-medium
    rounded-md
    shadow-lg shadow-[#9B1B5D]/20
    transition-colors
    flex items-center justify-center
    gap-2
  `}
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                {uploadProgress !== null ? `Envoi du document... ${uploadProgress}%` : "Création en cours..."}
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Créer la mission
              </>
            )}
          </button>
        </div>

        <br />
      </form>
    </div>
  );
};

export default CreateTodo;
